/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VoxtralCorrectionContextRequest } from '../../models/voxtral-correction-context-request';

export interface ApiBroadcastVoxtralCorrectionContextPost$Params {
      body?: VoxtralCorrectionContextRequest
}

export function apiBroadcastVoxtralCorrectionContextPost(http: HttpClient, rootUrl: string, params?: ApiBroadcastVoxtralCorrectionContextPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiBroadcastVoxtralCorrectionContextPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiBroadcastVoxtralCorrectionContextPost.PATH = '/api/Broadcast/voxtral-correction-context';
